import type { WuState, ProjectState } from "../types";

type ChipState = WuState | ProjectState | "needs-definition";

export default function StateChip({
  state,
  title,
}: {
  state: ChipState;
  title?: string;
}) {
  const key = String(state).toLowerCase().replace(/\s+/g, "-");
  const cls =
    key === "needs-definition" ? "chip chip-needs-def" : `chip chip-${key}`;
  return (
    <span className={cls} title={title}>
      {state}
    </span>
  );
}
